<template>
  <v-card title="下载日志">
    <div class="grid-demo">
      <v-more-panel>
        <v-form slot="form">
          <v-form-item label="业务单号">
            <v-input placeholder="" v-model="options.ywdh"></v-input>
          </v-form-item>
          <v-form-item label="UID">
            <v-input placeholder="" v-model="options.uid"></v-input>
          </v-form-item>
        </v-form>
        <v-form-item>
          <v-button type="primary" icon="search" @click="findList()"
            ><span>查询</span></v-button
          >
        </v-form-item>
      </v-more-panel>
    </div>
    <br />
    <vxe-grid v-bind="xGridOptions" size="mini" ref="xTable" :data="tableData">
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  kpsjq: "",
  kpsjz: "",
  zt: "2",
  ywdh: "",
  uid:""
};
let pagination = {
  sort: "kpsj",
  sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1,
};
let zt_options = [
  { value: "1", label: "成功" },
  { value: "2", label: "失败" },
];
export default {
  data() {
    return {
      pagination,
      options,
      zt_options,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 450,
        headerAlign: "center",
        loading:false,
        columns: [
          {
            field: "rn",
            title: "序号",
            align: "center",
            sortable: true,
          },
          {
            field: "ywdh",
            title: "业务单号",
            align: "center",
            sortable: true,
          },
          {
            field: "uid",
            title: "uid",
            align: "center",
            sortable: true,
          },
          {
            field: "jg",
            title: "异常结果",
            align: "center",
            sortable: true,
          },
          {
            field: "xzsj",
            title: "下载时间",
            align: "center",
            sortable: true,
          },
       
          
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.xGridOptions.loading=true
      this.$axios
        .get(
          "api/system/logcx/get-xzlog-list?cx=" +
            JSON.stringify(this.options),
          {
            params: this.pagination,
          }
        )
        .then((res) => {
          this.tableData = res.data.data;
          this.pagination.totalresult = res.data.total;
           this.xGridOptions.loading=false
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/xzlog.vue